export default "__VITE_ASSET__ff556202__"